import React from 'react';
import { DownloadIcon, DropletsIcon, HammerIcon, HomeIcon, LayersIcon, PaintbrushIcon, ShieldIcon, SprayCanIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
const icons: Record<string, React.ComponentType<{
  className?: string;
}>> = {
  roof: HomeIcon,
  paint: PaintbrushIcon,
  drywall: LayersIcon,
  wood: HammerIcon,
  sealing: DropletsIcon,
  cleaning: SprayCanIcon,
  prevention: ShieldIcon
};
export function MaintenanceTips() {
  const {
    t
  } = useLanguage();
  const lastIndex = t.care.items.length - 1;
  return <section className="w-full bg-cream py-16 lg:py-20" data-id="element-180" data-mp="c5njjimge0xh">
      <div className="mx-auto max-w-shell px-4 sm:px-6 lg:px-8" data-id="element-181" data-mp="g437ppu9tfch">
        <SectionHeading title={t.care.title} subtitle={t.care.subtitle} data-id="element-182" data-mp="l4hfr7vvgpai" />

        <ul className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8" data-id="element-183" data-mp="l2ee1qlcx7py">
          {t.care.items.map((item, index) => {
          const Icon = icons[item.id] ?? DropletsIcon;
          const wide = index === lastIndex;
          return <Reveal as="li" key={item.id} delay={Math.min(index, 5) * 0.04} className={`h-full ${wide ? 'sm:col-span-2 lg:col-span-3' : ''}`} data-id="element-184" data-mp="22a1spe7msrj4" data-mpi={index}>
                <article className={`flex h-full flex-col border-t-4 border-brand-500 bg-white p-7 shadow-card ${wide ? 'lg:flex-row lg:items-start lg:gap-8' : ''}`} data-id="element-185" data-mp="1tc83soc7505z">
                  <Icon className="h-8 w-8 shrink-0 text-brand-500" aria-hidden="true" data-id="element-186" data-mp="2h7klcrnfjovu" />
                  <div className={wide ? 'lg:flex-1' : ''} data-id="element-187" data-mp="2c99bigx4xedm">
                    <h3 className="mt-5 font-display text-lg font-extrabold uppercase tracking-wide text-ink lg:mt-0" data-id="element-188" data-mp="2c6wty4vah613">
                      {item.title}
                    </h3>
                    <p className="mt-3 text-sm leading-relaxed text-[#5B5B5B]" data-id="element-189" data-mp="34w3rb0j0bpkr">
                      {item.description}
                    </p>
                  </div>
                </article>
              </Reveal>;
        })}
        </ul>

        <Reveal delay={0.1} data-id="element-190" data-mp="3f1v7fjqq3wax">
          <div className="mt-12 text-center" data-id="element-191" data-mp="3f0k7jv0ef8p3">
            <a href="#contact" className="inline-flex items-center gap-2 rounded bg-ink px-7 py-4 font-display text-sm font-extrabold uppercase tracking-wide text-white transition-colors duration-200 ease-smooth hover:bg-brand-500 hover:text-ink" data-id="element-192" data-mp="3ezsk57gygh9w">
              <DownloadIcon className="h-4 w-4" aria-hidden="true" data-id="element-193" data-mp="3a0fopyc0q1vp" />
              {t.care.cta}
            </a>
          </div>
        </Reveal>
      </div>
    </section>;
}